export enum Context {
  block = 'block',
  modal = 'modal',
  text = 'text',
  box = 'box'
}
